import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { RoleAccessComponent } from './role-access.component';

@NgModule({
  declarations: [RoleAccessComponent],
  imports: [CommonModule, NgbModule],
  exports: [RoleAccessComponent],
})
export class RoleAccessModule {}
